import { throttle } from 'lodash';

/**
 * Fallback for css object-fit declaration
 * uses data attribute value 'data-fallback-img' to place background image on parent
 *
 * @return {void}
 */
const init = () => {
	const objectFit = 'object-fit' in document.body.style;
	const elems = { imgfit: document.querySelectorAll( '.spirit-image' ) };

	/**
	 * Fallback for object-fit styles.
	 * Adds background image to container if object-fit not supported.
	 * Uses data attribute value 'data-fallback-img' to place background image on parent.
	 *
	 * @returns {void}
	 */
	const imgFit = () => {
		if ( !objectFit ) {
			const elements = elems.imgfit;

			if ( !elements.length ) { return; }

			for ( let i = 0; i < elements.length; i++ ) {
				const el = elements[i];
				const imgcontain = el.querySelector( '.spirit-image__image-wrap' );
				const fbimg = el.querySelector( '[data-fallback-img]' ) ? el.querySelector( '[data-fallback-img]' ).getAttribute( 'data-fallback-img' ) : '';

				/**
				 * Default fallback background image
				 * @param {Object} element image container
				 * @returns {void}
				 */
				const defaultFallback = ( element ) => {
					if ( '' !== fbimg ) {
						const imgcont = element.querySelector( '.spirit-image__image-wrap' );
						const currentbg = imgcont.style.backgroundImage;
						let hasbg = false;

						if ( currentbg && `url( "${fbimg}" )` === currentbg ) {
							hasbg = true;
						}

						if ( !hasbg ) {
							imgcontain.style.backgroundImage = `url( "${fbimg}" )`;
						}
					}
				};

				/**
				 * Add container class if bg image added
				 * @param {Object} element image container
				 * @returns {void}
				 */
				const addContainerClass = ( element ) => {
					if ( !element.classList.contains( 'jdrf-compat-object-fit' ) ) {
						element.classList.add( 'jdrf-compat-object-fit' );
					}
				};

				if ( imgcontain ) {
					const sources = el.querySelectorAll( 'source' );

					if ( 0 < sources.length ) {
						sources.forEach( ( source ) => {
							const srcfbimg = source.getAttribute( 'data-src-fallback' );
							const srcbp = source.getAttribute( 'media' );
							const currentbg = imgcontain.style.backgroundImage;
							let hasbg = false;

							if ( currentbg && `url( "${srcfbimg}" )` === currentbg ) {
								hasbg = true;
							}

							if ( srcfbimg && srcbp &&
								window.matchMedia( srcbp ).matches &&
								!hasbg ) {
								addContainerClass( el );
								imgcontain.style.backgroundImage = `url( "${srcfbimg}" )`;
							} else {
								addContainerClass( el );
								defaultFallback( el );
							}
						} );
					} else {
						addContainerClass( el );
						defaultFallback( el );
					}
				}
			}
		}
	};

	imgFit();

	window.addEventListener( 'resize', throttle( imgFit, 200 ) );
};

export default { init };
